import { toast as sonnerToast } from 'sonner';

export const notifyInfo = (message, options) =>
  sonnerToast.success(message, {
    ...options,
  });

export const notifyError = (message, options) =>
  sonnerToast.error(message, {
    ...options,
  });
